import * as React from 'react';
import { connect } from 'react-redux';

import {
    Widget as WidgetAction,
    AvailableWidget as AvailableWidgetAction,
    SaveState as SaveStateAction
} from '../../actions';
import { AvailableWidget, Widget } from '../../store/models';

import WidgetMenu from './WidgetMenu';

interface IProps {
    availableWidgets: AvailableWidget[],
    widgetUsageCounts: Object,
    addWidget: Function,
    listAvailableWidgets: Function,
    setDirty: Function,
}

function onAdd(widget: AvailableWidget, props: IProps) {
    props.addWidget(new Widget(widget.type, widget.getDefaultSettings()));
    props.setDirty();
}

class WidgetMenuContainer extends React.Component<IProps, void> {
    static propTypes = {
        availableWidgets: React.PropTypes.array.isRequired,
        widgetUsageCounts: React.PropTypes.object.isRequired,
        addWidget: React.PropTypes.func.isRequired,
        listAvailableWidgets: React.PropTypes.func.isRequired,
        setDirty: React.PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.listAvailableWidgets();
    }

    render() {
        const { availableWidgets, widgetUsageCounts } = this.props;

        return (
            <WidgetMenu availableWidgets={availableWidgets} widgetUsageCounts={widgetUsageCounts} onClick={(widget: AvailableWidget) => onAdd(widget, this.props)} />
        );
    }
}

const mapStateToProps = state => ({
    availableWidgets: state.availableWidgets,
    widgetUsageCounts: state.widgetUsageCounts
});

export default connect(
    mapStateToProps,
    {
        addWidget: WidgetAction.addWidget,
        listAvailableWidgets: AvailableWidgetAction.listAvailableWidgets,
        setDirty: SaveStateAction.dirty
    }
)(WidgetMenuContainer);


// WEBPACK FOOTER //
// ./src/components/widgetMenu/WidgetMenuContainer.tsx